import { createChatBotMessage } from "react-chatbot-kit";
import TrackOrder from "./TrackOrder";
import TrackOrderLink from "./TrackOrderLink";

const buttonStyle = {
  border: `1px solid ${process.env.REACT_APP_THEAM_COLOR}`,
  borderRadius: "25px",
  padding: "2px 20px",
  fontSize: 14,
  color: `${process.env.REACT_APP_THEAM_COLOR}`,
  background: "transparent",
  cursor: "pointer",
  transition: "all 0.3s ease-in-out",
};

const config = {
  botName: `${window.location.hostname}`,
  initialMessages: [
    createChatBotMessage("How can we help?", {
      widget: "options",
    }),
  ],
  widgets: [
    {
      widgetName: "options",
      widgetFunc: (props) => (
        <>
          <button
            onClick={() => props.actionProvider.handleTrackOrder()}
            style={buttonStyle}
            className="mb-2"
          >
            Know Order
          </button>
          <div className="d-flex gap-2">
            <button
              onClick={() => props.actionProvider.handleContact()}
              style={buttonStyle}
            >
              Contact Us
            </button>
            <button
              onClick={() => props.actionProvider.handleTrackLink()}
              style={buttonStyle}
            >
              Track Order
            </button>
          </div>
        </>
      ),
    },
    {
      widgetName: "trackOrder",
      widgetFunc: (props) => <TrackOrder {...props} />,
    },
    {
      widgetName: "trackOrderLink",
      widgetFunc: (props) => <TrackOrderLink {...props} />,
    },
  ],
};

export default config;
